import React, { useState } from 'react';
import Layout from '../../../app/Layout';
import Breadcrumb from '../General/Breadcrumb';
import HeaderContent from '../General/HeaderContent';
import SpinnerLoading from '../../components/Spinners/SpinnerLoading';
import DataTableComponent from "../../components/plugins/DataTableComponent";
import PieChart from './PieChart';
import { faHashtag,faListAlt,faDollarSign, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormularioFiltroVentasR from './FormularioFiltroVentasR';
import {Badge, Table} from "react-bootstrap"
import FormularioFiltroVentasAsesor from './FormularioFiltroVentasAsesor';
const ReporteVentas = () => {

   
    const [loading, setLoading] = useState(false)
    const [datosTabla,setDatosTabla] = useState({data:[],grafico:null,tabla_vendedores:null})
    const {usuario} = useSelector(state=>state.usuario)

    
    return (
        <Layout>
            <div className="ControlReportes">
                <div className="ControlReportes__header">
                <HeaderContent title='Reporte de Ventas cerradas' />
                <Breadcrumb
                    link={[
                    { url: "/inicio", nombre: "Inicio", icon: "fas fa-home" },
                    { url: "", nombre: "Reportes" },
                    { url: "", nombre: "Ventas" },
                    ]}
                />
                </div>
                <div className="ControlReportes__body">
                    <div className='row'>
                        <div className='col-md-6'>
                        {  
                          usuario.id_tp_nivel_usuario!=="11" ?
                          <FormularioFiltroVentasR setDatosTabla={setDatosTabla} setLoading={setLoading} usuario={usuario} datosTabla={datosTabla} /> : 
                          <FormularioFiltroVentasAsesor setDatosTabla={setDatosTabla} setLoading={setLoading} usuario = {usuario} datosTabla={datosTabla} /> 
                        }

                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-8'>
                            <SpinnerLoading loading={loading}>
                                <div className="card">
                               
                                    <div className="card-body">
                                    <h5
                                        style={{ color: "#434343" }}
                                        >
                                        <FontAwesomeIcon icon={faListAlt} /> Lista de ventas cerradas
                                    </h5>
                             
                                    <DataTableComponent
                                        colums={colums(usuario)}
                                        tabla={datosTabla.data}
                                        keyField="id_lead"
                                    />
                                    </div>
                                </div>
                            </SpinnerLoading>
                        </div> 
                        { datosTabla.tabla_vendedores?.length ? <div className='col-md-4'>
                            <div className='row'>
                                <div className='col-md-12'>
                                {  usuario.id_tp_nivel_usuario!=="11" ?  <div className='card mb-2'>
                                    <div className='card-body'>
                                    <Table>
                                        <thead>
                                            <tr> 
                                            <th>
                                                    Asesor
                                                </th>
                                                <th>
                                                    Cantidad
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                datosTabla.tabla_vendedores.map((venta,i)=>{
                                                  return  <tr key={i}>
                                                        <td>{venta.nombre_usuario}</td>
                                                        <td className='text-center'>{venta.cantidad}</td>
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                    </div>
                                    </div>: null}
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-4 d-flex justify-content-center align-items-center'>
                                                <FontAwesomeIcon icon={faMoneyBillWave} size='3x' color={'#27314A'} />
                                            </div>
                                            <div className='col-md-8 text-center'>
                                                <h3>{datosTabla.importe_total}</h3>
                                                <p>Importe total</p>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-4 d-flex justify-content-center align-items-center'>
                                                <FontAwesomeIcon icon={faHashtag} size='3x' color={'#27314A'} />
                                            </div>
                                            <div className='col-md-8 text-center'>
                                                <h3>{datosTabla.data.length}</h3>
                                                <p>N° de registros</p>
                                            </div>
                                        </div>
                                      
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div> : <div className='col-md-4'><div className='card'><div className='card-body'>Sin datos por mostrar</div></div></div>} 
                    </div> 
                </div>

            </div>
        </Layout>
    );
};

export default ReporteVentas;

const colums = (formatTiempo,usuario) => [
    {
      name: "Nombres",
      selector: "nombres",
      align: "center",
      sortable: true,
      className: "nombres",
      compact:true,
      wrap:true,
      width:"100px"
    },
    {
      name: "Apellidos",
      selector: "apellidos",
      align: "center",
      sortable: true,
      className: "apellidos",
      compact:true,
      wrap:true,
      width:"100px"
    }
    ,
    {
      name: "Fase",
      selector: "nombre_fase",
      align: "center",
      className: "nombre_fase",
      sortable: true,
      width:"100px",
      wrap:true
    }

    ,
    {
      name: "Fecha Cierre",
      selector: "fecha_cierre",
      align: "center",
      className: "fecha_cierre",
      sortable: false,
      wrap:true,
    }
    ,
    {
      name: "Importe",
      selector: "importe",
      align: "center",
      className: "importe",
      sortable: true
    }
    ,
    {
      name: "Producto",
      selector: "nombre_proyecto",
      align: "center",
      className: "producto",
      sortable: true,
      wrap:true,
    }
    ,
    {
        name: "Firma Contrato",
        selector: "activo",
        align: "center",
        className: "activo",
        sortable: true,
        wrap:true,
        cell:(record)=> <Badge variant={record.activo==="1"?'warning':'success'} >{record.activo==="1"?'Pendiente':'Completado'}</Badge>
    
    
    }
    ,    
    {
      name: "Asesor",
      selector: "nombre_usuario",
      align: "center",
      className: "nombre_asesor",
      sortable: true,
      width:"100px",
      wrap:true,
    }
    
  ];